import { Box, styled, SxProps } from '@mui/material';

export const drawerStyles: SxProps = {
  '& .MuiDrawer-paper': {
    width: {
      xs: '100vw',
      sm: '100vw',
      md: '80%',
      lg: '60%',
    },
  },
};

export const DrawerContent = styled(Box)({
  height: '100vh',
  overflow: 'auto',
});
